<template>
  <div>
    <header class="list-filters">
      <form method="get" action="" @submit.prevent="onSubmit">
        <div class="d-flex gap-3 align-items-end">
          <div class="form-group mb-0">
            <label>Busca</label>
            <input type="text" v-model="search.term" class="form-control" />
          </div>

          <div class="form-group mb-0">
            <label>Ordem</label>
            <select v-model="search.order" class="form-control">
              <option value="-created_at">
                Data de cadastro (decrescente)
              </option>
              <option value="created_at">Data de cadastro</option>
              <option value="from">Alfabética</option>
            </select>
          </div>

          <div class="form-group mb-0">
            <label>Resultados</label>
            <select v-model="search.limit" class="form-control">
              <option value="100">100</option>
              <option value="-1">Todos</option>
            </select>
          </div>

          <button class="btn btn-primary small" type="submit">Filtrar</button>
        </div>
      </form>
    </header>
    <div class="stats d-flex justify-content-between my-3 align-items-center">
      <span
        >Total {{ result.total }} redirecionamento{{
          result.total == 1 ? "" : "s"
        }}</span
      >
      <span v-if="result.to > 1">
        <span class="mr-3"
          >Mostrando de {{ result.from }} a {{ result.to }}</span
        >
        <button
          class="btn small"
          :disabled="!result.prev_page_url"
          @click="paginatePrev"
        >
          &lt;&lt;
        </button>
        <button
          class="btn small"
          :disabled="!result.next_page_url"
          @click="paginateNext"
        >
          &gt;&gt;
        </button>
      </span>
    </div>
    <table class="sellers table w-100">
      <thead>
        <tr>
          <th>De</th>
          <th>Para</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in result.data">
          <td>{{ row.from }}</td>
          <td>{{ row.to }}</td>
          <td class="text-right nbsp">
            <a
              class="btn small"
              :href="`https://${url}/${row.from}`"
              target="_blank"
              >Ver</a
            >

            <router-link
              class="btn btn-primary small"
              :to="'/project/' + project.id + '/redirects/edit/' + row.id"
              >Editar</router-link
            >
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-show="result.total"
      class="stats d-flex justify-content-between my-3 align-items-center"
    >
      <span
        >Total {{ result.total }} redirecionamento{{
          result.total == 1 ? "" : "s"
        }}</span
      >
      <span v-if="result.to > 1">
        <span class="mr-3"
          >Mostrando de {{ result.from }} a {{ result.to }}</span
        >
        <button
          class="btn small"
          :disabled="!result.prev_page_url"
          @click="paginatePrev"
        >
          &lt;&lt;
        </button>
        <button
          class="btn small"
          :disabled="!result.next_page_url"
          @click="paginateNext"
        >
          &gt;&gt;
        </button>
      </span>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      result: {
        data: [],
      },
      search: {
        page: 1,
        order: "-created_at",
        term: "",
        limit: "100",
      },
    };
  },
  computed: {
    project() {
      return this.$store.state.project;
    },
    url() {
      if (this.project.domain) return this.project.domain;
      return `${this.project.slug}.${process.env.VUE_APP_BASEURL}`;
    },
  },
  methods: {
    dataBr(data) {
      var d = new Date(data);
      return (
        ("0" + d.getDate()).substr(-2) +
        "/" +
        ("0" + (d.getMonth() + 1)).substr(-2) +
        "/" +
        d.getFullYear()
      );
    },
    paginatePrev() {
      this.search.page = this.result.prev_page_url.match(/page=(\d+)/).pop();
      this.getResults();
    },
    paginateNext() {
      this.search.page = this.result.next_page_url.match(/page=(\d+)/).pop();
      this.getResults();
    },
    onSubmit() {
      this.search.page = 1;
      this.getResults();
    },

    getResults() {
      var query =
        "?" +
        Object.keys(this.search)
          .filter((key) => this.search[key])
          .map((key) => key + "=" + this.search[key])
          .join("&");

      axios({
        url: `/api/projects/${this.project.id}/redirects${query}`,
      }).then((res) => {
        console.log(res.data);
        this.result = res.data;
        history.replaceState(null, "query", query);
      });
    },
  },
  mounted() {
    this.search = { ...this.search, ...this.$route.query };
    this.getResults();
  },
};
</script>

<style scoped>
table tbody {
  font-size: 0.9em;
}
</style>
